import React, { useEffect, useState } from "react";
import { Empirica, DefaultURL } from "../empirica";
import { GlobalContext } from "./Context";
export const EmpiricaGlobal = (props) => {
    const [globalAttr, setGlobalAttr] = useState(null);
    const url = props.url || DefaultURL;
    useEffect(() => {
        setGlobalAttr(Empirica.globalAttributes(url));
    }, []);
    return (React.createElement(GlobalContext.Provider, { value: globalAttr }, props.children));
};
